import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_REVENUE_BANDITS_PSF_COMBO_EXPERIMENT = createFcmDetails(
	'revenue_bandits_psf_combo_experiment',
	{
		owner: 'Revenue',
		context: 'Psf Combo Page',
		description: 'Revenue Bandits PSF Combo Experiment',
		import: false,
		template: {
			treatment_traffic_percentage: 50,
			enabled: true,
			exp_name_suffix: 'bandit_v2',
			bandit_amounts: [3, 5, 10, 20, 25],
			contextual_button_amounts: [
				{
					amounts: [25, 40],
				},
				{
					amounts: [25, 55],
				},
				{
					amounts: [30, 60],
				},
			],
		},
	},
);
